import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Button, Form, Card, Alert } from 'react-bootstrap';
import './manage-assistants.css';

const CATEGORIES = [
    "Infrastructure",
    "Canteen",
    "EduPrime",
    "Examination",
    "Academics",
    "Fee Payments and Accounts",
    "Hostel Food",
    "Extracurricular and Events",
    "Security",
    "Sports",
    "Housekeeping",
    "Audio-Visual Equipment",
    "Parking",
    "Transport",
    "Library",
    "IT and Networking",
    "Others",
];

const ManageAssistants = ({ onBack }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const baseUrl = process.env.REACT_APP_COMPLAINTS_APP_BE_URL;

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else if (location.state?.from) {
            navigate(location.state.from);
        } else if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate('/adminpage');
        }
    };

    const handleAddAssistant = async (e) => {
        e.preventDefault();
        setMessage(null);
        setError(null);
        if (!email.toLowerCase().endsWith("@vnrvjiet.in")) {
        setError("Please enter official @vnrvjiet.in email of assistant");
        return;
    }
        try {
            const token = localStorage.getItem("authToken");
            await axios.post(`${baseUrl}/admin-api/add-assistant`, {
                email,
                name,
                categories: selectedCategories
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage(`Assistant ${name} added successfully!`);
            setEmail("");
            setName("");
            setSelectedCategories([]);
        } catch (err) {
            setError(err.response?.data?.message || "Failed to add assistant");
        }
    };

    return (
        <div className="container mt-4">
            <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                <Button
                    variant="secondary"
                    onClick={handleBack}
                    className="mb-3"
                >
                    ← Back
                </Button>
                <Card className="p-4 shadow-sm">
                <h3 className="mb-4 text-center">Manage Assistants</h3>

                {message && <Alert variant="success">{message}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleAddAssistant}>
                    <Form.Group className="mb-3">
                        <Form.Label>Assistant Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Assistant Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label>Assign Categories</Form.Label>
                        <div className="d-flex flex-wrap gap-2 p-2 border rounded bg-light" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                            {CATEGORIES.map(cat => (
                                <Form.Check
                                    key={cat}
                                    type="checkbox"
                                    id={`cat-${cat}`}
                                    label={cat}
                                    checked={selectedCategories.includes(cat)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedCategories([...selectedCategories, cat]);
                                        } else {
                                            setSelectedCategories(selectedCategories.filter(c => c !== cat));
                                        }
                                    }}
                                    className="me-3"
                                />
                            ))}
                        </div>
                    </Form.Group>

                    <Button variant="primary" type="submit" className="w-100">
                        Add Assistant
                    </Button>
                </Form>
            </Card>
            </div>
        </div>
    );
};

export default ManageAssistants;
